import { CSSProperties } from "react";
import { Tooltip } from "antd";
import { InfoCircleOutlined } from "@ant-design/icons";
import { colors } from "shared/theme/color";
import { textPx } from "shared/constants/zoom";

// Clean table treatment (prototype `table.tbl`): minimalist uppercase ink-3
// column headers and tabular numerals for numeric cells. Shared by the
// design-system table retouches.
export const thStyle: CSSProperties = {
  textTransform: "uppercase",
  fontSize: textPx(11),
  fontWeight: 600,
  letterSpacing: "0.06em",
  color: colors.ink3,
};

// Optional `info` renders the same info-icon-tooltip affordance MetricCard
// uses for ambiguous KPI figures, extended to table column headers — for
// columns like a bare "Pendapatan" where the basis (earned vs cash,
// per-credit proration, membership exclusion) isn't obvious from the label
// alone and there's no other framing on the page to explain it.
export const th = (label: string, info?: string) =>
  info ? (
    <span style={{ ...thStyle, display: "inline-flex", alignItems: "center", gap: 4 }}>
      {label}
      {/* Anchored to the icon's right edge: a last column's icon can sit
          within a tooltip's half-width of the viewport edge, where a centred
          box is pushed flush against the window with its arrow off-centre. */}
      <Tooltip title={info} placement="topRight" arrow={{ pointAtCenter: true }}>
        <InfoCircleOutlined style={{ fontSize: textPx(11), cursor: "help" }} />
      </Tooltip>
    </span>
  ) : (
    <span style={thStyle}>{label}</span>
  );

export const tnum: CSSProperties = { fontVariantNumeric: "tabular-nums" };
